module.exports = __webpack_public_path__ + "static/media/zeid-profile-picture.0d8cf1f1.jpg";